import React from "react"
import "./styles/NotFound.css"

function NotFound() {
  return <div className="lost">You Are Lost Buddy! </div>
}

export default NotFound
